import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpinnerLoading = _resolveComponent("SpinnerLoading")!
  const _component_PatientCancellationWarning = _resolveComponent("PatientCancellationWarning")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.patients === undefined || _ctx.patients === null)
      ? (_openBlock(), _createBlock(_component_SpinnerLoading, {
          key: 0,
          class: "mt-50"
        }))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_swiper, {
      "slides-per-view": 1,
      loop: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: true,
    },
      pagination: {
            clickable: true,
        },
      modules: _ctx.modules,
      class: "mb-25"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.patients, (patient) => {
          return (_openBlock(), _createBlock(_component_swiper_slide, {
            key: patient.id!
          }, {
            default: _withCtx(() => [
              _createVNode(_component_PatientCancellationWarning, {
                patient: patient,
                show_link: true
              }, null, 8 /* PROPS */, ["patient"])
            ]),
            _: 2 /* DYNAMIC */
          }, 1024 /* DYNAMIC_SLOTS */))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modules"])
  ], 64 /* STABLE_FRAGMENT */))
}